import React from 'react';
import PropTypes from 'prop-types';
import UpdatedBy from '../runBookLog/updatedBy';

const ClinicRunBookLogItem = ({ clinicRunBookLog }) => (
  <>
    <div className="date-note-logs-text">
      Note:&nbsp;
      {clinicRunBookLog.newValue?.notes && clinicRunBookLog.newValue?.notes}
    </div>
    <div>
      Date:&nbsp;
      {clinicRunBookLog.newValue?.dateNoteLogged &&
        clinicRunBookLog.newValue?.dateNoteLogged}
    </div>
    <div>
      {clinicRunBookLog.newValue?.updatedByLogin && (
        <UpdatedBy updatedBy={clinicRunBookLog.newValue?.updatedByLogin} />
      )}
    </div>
  </>
);

ClinicRunBookLogItem.propTypes = {
  clinicRunBookLog: PropTypes.shape().isRequired,
};

export default ClinicRunBookLogItem;
